import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { colors } from "../colors_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";
import {
  loadingTextHTML,
  fillLoadedText,
  currentPasswordSplainerHTML,
  renderCurrentPasswordSplainer,
} from "./accountDetailsUI_v2.js";

const render = async ({ showStopSecNag }) => {
  // The identity token doesn't carry the question, and nothing ever returns
  // the answer (the server keeps only a hash). The pop-up opens right away
  // with placeholders, then fills them in from getMyAccount.
  const html = `
    <div class="popUpHead">Change Security Question</div>
    <div class="changeSecQA">
      <div>Current Security Question:</div>
      <div>${loadingTextHTML("currentSecQ")}</div>
    </div>
    <div class="changeSecQA">
      <div>Current Security Answer:</div>
      <div>${loadingTextHTML("currentSecAStatus")}</div>
    </div>
    <form id="changeSecQAform">
      <div class="center changeSecQA">
        <label for="newSecQInput">New Security Question:</label>
        <input class="bottom7" type="text" id="newSecQInput" autocomplete="off" placeholder="e.g. Food I Hate">
        <div class="inputMessages center" id="newSecQMessage"></div>
      </div>
      <div class="center changeSecQA">
        <label for="newSecAInput">New Security Answer:</label>
        <input class="bottom7" type="text" id="newSecAInput" autocomplete="off" placeholder="e.g. Tomatoes">
        <div class="inputMessages center" id="newSecAMessage"></div>
      </div>
      <div class="center changeSecQA">
        <label for="secQAPasswordInput">Current Password:${currentPasswordSplainerHTML("secQAPasswordSplainer")}</label>
        <input class="bottom7" type="password" id="secQAPasswordInput" autocomplete="current-password">
      </div>
      <br>
      <div class="center">
        <div>Allows you to recover your account if you forget your password.</div>
        <div>Answers aren't case sensitive.</div>
      </div>
      <br>
      <div class="center">
        <button 
          type="submit" 
          id="changesecQASubmit" 
          class="submitButton bottom7 button workADayButtons">
          Submit
        </button>
        <div class="inputMessages center" id="changeSecQASubmitMessage"></div>
      </div>
    </form>
    <div id="stopSecNagDiv">
    </div>
  `;

  dasModal.render(html);
  document.getElementById("secQAPasswordInput").style.backgroundColor =
    colors.getGameColor("lighterAccent");

  const newSecQInput = document.getElementById("newSecQInput");
  // newSecQInput.addEventListener("keyup", handleKeyUp);
  newSecQInput.style.backgroundColor = colors.getGameColor("lighterAccent");
  newSecQInput.focus();

  const newSecAInput = document.getElementById("newSecAInput");
  // newSecAInput.addEventListener("keyup", handleKeyUp);
  newSecAInput.style.backgroundColor = colors.getGameColor("lighterAccent");

  //const changeSecQASubmitMessage = document.getElementById(
  //  "changeSecQASubmitMessage"
  //);
  //const changeSecQAform = document.getElementById("changeSecQAform");
  // changeSecQAform.addEventListener("submit", handleSubmit);
  if (showStopSecNag === true) {
    renderStopSecNag();
  }

  // Now fill in the current question (textContent: it's user-entered text)
  const accountResult = await identityService.getMyAccount();
  if (accountResult.status != 200) {
    const message = accountResult.message || "Unable to load";
    fillLoadedText("currentSecQ", message);
    fillLoadedText("currentSecAStatus", "");
    return;
  }
  const account = accountResult.account;
  fillLoadedText(
    "currentSecQ",
    account.secQ.length > 0 ? account.secQ : "(none)",
  );
  fillLoadedText("currentSecAStatus", account.hasSecQA ? "(hidden)" : "(none)");
};

const renderStopSecNag = () => {
  const stopSecNagDiv = document.getElementById("stopSecNagDiv");
  const html = `<button 
        id="stopSecNag" 
        class="bottom7 button workADayButtons">
        Don't Show This Again
      </button>
      <div class="inputMessages center" id="stopSecNagMsg">
      </div>`;
  stopSecNagDiv.innerHTML = html;
  colors.setButtonColors();
  // document
  //   .getElementById("stopSecNag")
  //   .addEventListener("click", handleStopSecNag);
};

const handleStopSecNag = async (event) => {
  // event.preventDefault();
  const stopSecNagMsg = document.getElementById("stopSecNagMsg");
  const stopSecNagButton = document.getElementById("stopSecNag");
  stopSecNagMsg.innerText = "Submitting. This takes a moment...";
  document.body.style.cursor = "wait";
  stopSecNagButton.disabled = true;
  await new Promise(requestAnimationFrame);
  const result = await identityService.stopSecNag();
  document.body.style.cursor = "default";
  stopSecNagMsg.innerText = "";
  stopSecNagButton.disabled = true;
  if (result.status === 200) {
    dasModal.close();
    profile.render("normal");
  }
};

const handleSubmit = async (event) => {
  // event.preventDefault();
  const secQ = document.getElementById("newSecQInput").value;
  const secA = document.getElementById("newSecAInput").value;
  const currentPassword = document.getElementById("secQAPasswordInput").value;
  const resultSecQ = identityService.isSecQAValid(secQ);
  const resultSecA = identityService.isSecQAValid(secA);
  const messageElement = document.getElementById("changeSecQASubmitMessage");
  const changesecQASubmit = document.getElementById("changesecQASubmit");

  if (resultSecQ.status != 200 || resultSecA.status != 200) {
    messageElement.innerText = "Please correct the errors above";
    return;
  }
  if (currentPassword.length === 0) {
    messageElement.innerText = "Please enter your current password";
    return;
  }
  messageElement.innerText = "Submitting...";
  changesecQASubmit.disabled = true;
  changesecQASubmit.style.cursor = "wait";
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  const result = await identityService.setSecQA({ secQ, secA, currentPassword });
  messageElement.innerText = "";
  changesecQASubmit.disabled = false;
  changesecQASubmit.style.cursor = "default";
  document.body.style.cursor = "default";
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  if (result.status === 200) {
    dasModal.close();
    profile.render("small");
    dasModal.render(
      `<div class="max">The security question has been updated.</div>`,
    );
    return;
  }
};

const handleKeyUp = (event) => {
  const inputElement = event.target;
  // event.stopPropagation();
  const secQA = inputElement.value;
  let messageElement;
  switch (inputElement.id) {
    case "newSecQInput":
      messageElement = document.getElementById("newSecQMessage");
      break;
    case "newSecAInput":
      messageElement = document.getElementById("newSecAMessage");
      break;
  }

  const result = identityService.isSecQAValid(secQA);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

eventHub.registerEvent("keyup", "newSecQInput", handleKeyUp);
eventHub.registerEvent("keyup", "newSecAInput", handleKeyUp);
eventHub.registerEvent("submit", "changeSecQAform", handleSubmit);
eventHub.registerEvent("click", "stopSecNag", handleStopSecNag);
eventHub.registerEvent(
  "click",
  "secQAPasswordSplainer",
  renderCurrentPasswordSplainer,
);

export const changeSecQAPop = {
  render,
};
